import { render, staticRenderFns } from "./AccordionControllerMode.vue?vue&type=template&id=b095ea20"
import script from "./AccordionControllerMode.vue?vue&type=script&lang=js"
export * from "./AccordionControllerMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports